import { layers } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function LayerSection() {
  return (
    <section id="layers" className="w-full bg-background-100 border-b border-background-200">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="04"
              kicker="LAYER BY LAYER"
              title="图文逐层拆解：一层一层往下看"
              desc="同一件事有五个层次。黑料图文深扒的写法是从最表层往下走，每剥开一层，上一层的解释就会松动一点。"
            />
            <div className="mt-8 rounded-lg border border-background-300 bg-background-50 p-5">
              <p className="text-xs tracking-[0.2em] text-foreground-500 font-label">当前解析深度</p>
              <p className="mt-3 font-heading text-4xl font-bold text-primary-600">5 / 5</p>
              <div className="mt-4 h-1.5 rounded-full bg-background-200 overflow-hidden">
                <span className="block h-full w-full bg-accent-500"></span>
              </div>
              <p className="mt-3 text-xs text-foreground-600 font-label">全貌层已完成，可回看任意中间层</p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3 md:space-y-4">
              {layers.map((layer, idx) => {
                const isLast = idx === layers.length - 1;
                return (
                  <div
                    key={layer.id}
                    className={`flex flex-col sm:flex-row sm:items-center gap-4 rounded-lg border p-4 md:p-5 transition-colors ${
                      isLast
                        ? 'border-primary-300 bg-primary-100/60'
                        : 'border-background-300 bg-background-50 hover:border-secondary-400'
                    }`}
                  >
                    <span className={`shrink-0 w-12 h-12 rounded-md flex items-center justify-center font-heading text-xl font-bold ${
                      isLast ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}>
                      {layer.level}
                    </span>
                    <div className="flex-1">
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{layer.name}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600 font-body">{layer.text}</p>
                    </div>
                    <span className={`hidden sm:flex shrink-0 w-9 h-9 items-center justify-center rounded-full ${
                      isLast ? 'bg-accent-500 text-background-50' : 'bg-background-100 text-foreground-500'
                    }`}>
                      <i className={isLast ? 'ri-check-double-line text-lg' : 'ri-arrow-down-line text-lg'}></i>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}